/**
 * Application constants shared across the frontend.
 */

export const TIME_SETTINGS = {
  /** Hours per corporate working day (used for d/w/mon/y conversions). */
  CORPORATE_WORKING_HOURS: 8,
};
